import { List, Input, Skeleton, Badge, Spin, Col } from "antd";
import { FaUserCircle } from "react-icons/fa";
import { IChat } from "../../../../models/chat/response";
import { useTranslation } from "react-i18next";
import { useContext, useRef, useState } from "react";
import ChatContext from "../../../../context/chat/context";
import { debounce } from "lodash";
import AppContext from "../../../../context/app/context";

const ChatSidebar = ({
    chatsContainerRef,
    setHasMoreMessages,
}) => {
    const { t } = useTranslation();
    const { list: chats, query, loading, selectedChatId, actions } = useContext(ChatContext);
    const [searchText, setSearchText] = useState(query.keyword || "");
    const { screenSize } = useContext(AppContext);
    const debouncedSearch = useRef(
        debounce((keyword: string) => {
            keyword == '' ? actions.setQuery({ page: 1 }) :
                actions.setSearch(keyword);
        }, 400)
    ).current;

    const handleChatSelect = (chatId: number) => {
        actions.setSelectedChatId(chatId);
        actions.setMessageQuery({ chatId, page: 1 });
        setHasMoreMessages(true);
        window.history.pushState({}, "", `?chatId=${chatId}`);
    };

    return (
        <Col style={{ height: "100%", borderRight: "1px solid #2b363a" }}>
            <div style={{ textAlign: "center", borderBottom: "1px solid #2b363a" }}>
                <Input
                    placeholder={t("search_hint")}
                    value={searchText}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSearchText(value);
                        debouncedSearch(value);
                    }}
                    style={{ margin: "10px", maxWidth: "280px", borderRadius: "20px" }}
                />
            </div>
            {loading.includes("list") && query.page === 1 ? (
                <>
                    <div>
                        {[...Array(8)].map((_, i) => (
                            <div key={i} style={{ padding: "5px" }}>
                                <Skeleton.Button active size="large" block />
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <List
                    size="small"
                    style={{ height: "91%", overflowY: "auto" }}
                    dataSource={chats}
                    renderItem={(item: IChat) => (
                        <List.Item
                            style={{
                                padding: "10px",
                                cursor: "pointer",
                                backgroundColor: String(selectedChatId) === String(item.id) ? "#57a5a5" : "transparent",
                                borderRadius: "8px",
                                margin: "5px",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                height: "60px",
                            }}
                            onClick={() => handleChatSelect(item.id)}
                        >
                            <FaUserCircle
                                size={36}
                                color={String(item.id) === String(selectedChatId) ? "#fff" : "#57a5a5"}
                            />
                            <div style={{ flex: 1, textAlign: "start" }}>
                                <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{item.name || "لا يوجد اسم"}</div>
                                <div style={{ color: "#555", fontSize: item.name ? "0.9rem" : "1rem" }}>
                                    {item.phone || "رقم الهاتف غير متوفر"}
                                </div>
                            </div>
                            {item.unseen_message_count > 0 && (
                                <Badge count={item.unseen_message_count} style={{ backgroundColor: "#ff4d4f" }} />
                            )}
                        </List.Item>
                    )}
                    footer={
                        loading.includes("list") && chats?.length !== 0 ? (
                            <div style={{ textAlign: "center", padding: "8px" }}>
                                <Spin />
                            </div>
                        ) : null
                    }
                    ref={chatsContainerRef}
                />
            )}
        </Col>
    );
};

export default ChatSidebar;
